import { createContext } from "react";
import Ecosystem from "../../models/ecosystem.model";
import { LabelValueInterface } from "../../models/common.models";


export enum WORK_TYPE {
  PRESENTIAL = "presential",
  REMOTE = "remote",
  HYBRID = "hybrid",
}

export interface SelectLabelValue extends LabelValueInterface {}


export interface JobofferQuery {
  diversity?: string | string[];
  ecosystem?: string;
  experience?: string | string[];
  hireTypes?: string | string[];
  skills?: string | string[];
  currency?: string;
  maxSalary?: string;
  minSalary?: string;
  workplace?: string;
  workType?: string[];
  language_id?: string;
  language_level?: string[];
}

export interface JobofferForm {
  diversity?: SelectLabelValue[];
  ecosystem?: Ecosystem;
  experience?: SelectLabelValue[];
  hireTypes?: SelectLabelValue[];
  currency?: SelectLabelValue;
  salary?: string;
  skills?: SelectLabelValue[];
  workplace?: string;
  workType?: SelectLabelValue[];
  language?: SelectLabelValue;
  language_level?: SelectLabelValue[];
  plusInfo?: string;
}

export interface IJobOfferProps {}

export interface IJobOfferModel {
  ecosystems?: Ecosystem[] | null | undefined;
  experienceTimes?: JobofferForm["experience"];
  feedbackVisible?: boolean;
  maxSalary?: string;
  minSalary?: string;
  skillsList?: JobofferForm["skills"];
  skillsSelectValues?: JobofferForm["skills"];
  workTypes?: JobofferForm["workType"];
  english?: SelectLabelValue[];
}

export interface IJobOfferController {
  handleFormChange: (part: Partial<JobofferForm>) => void;
  jobofferform?: JobofferForm;
  joinTextExperience: (exp: JobofferForm["experience"]) => string;
  joinTextCurrency: (currency?: JobofferForm["currency"]) => string;
  joinTextSalary: (salary?: JobofferForm["salary"]) => string;
  joinTextSkills: (skills?: SelectLabelValue[]) => string | undefined;
  joinTextDiversity: (divs?: SelectLabelValue[]) => string | undefined;
  joinTextLanguage: (lang?: SelectLabelValue) => string;
  joinTextLanguageLevel: (level?: SelectLabelValue[]) => string;
  joinTextWorkType: (wt: JobofferForm["workType"]) => string;
  onCreateJobOffer: () => void;
  updateJobOffer: () => void;
  onResetJobOffer: () => void;
}

export const JobOfferContext = createContext<IJobOfferContext>({
  handleFormChange: () => {},
  joinTextExperience: () => "",
  joinTextCurrency: () => "",
  joinTextSalary: () => "",
  joinTextSkills: () => "",
  joinTextWorkType: () => "",
  joinTextDiversity: () => "",
  joinTextLanguage: () => "",
  joinTextLanguageLevel: () => "",
  onCreateJobOffer: () => {},
  onResetJobOffer: () => {},
  updateJobOffer: () => {},
});

export const INITIAL_STATE_JOBOFFER: IJobOfferProps = {};

export interface IJobOfferContext extends IJobOfferModel, IJobOfferController {}
